import { styled } from "@sourceful/shared-components";
import { SanityTechnicalContentSection } from "@sourceful/shared-types";
import toRem from "@styles/postprocess/conversion/to-rem";
import { BasePageSection } from "../BasePageSection";
import TechnicalContent from "@components/technicalContent/TechnicalContent";

const TechnicalContentSectionWrapper = styled("div", {
  margin: "0 auto",
  marginBottom: toRem(40),
});

interface TechnicalContentSectionProps {
  section: SanityTechnicalContentSection;
}

export const TechnicalContentSection = ({ section }: TechnicalContentSectionProps) => {
  return (
    <BasePageSection section={section}>
      <TechnicalContentSectionWrapper>
        {section?.technicalContentItems?.map((technicalContentItem, index) => (
          <div style={{ marginTop: "40px" }} key={`${technicalContentItem._key}-${index}`}>
            <TechnicalContent technicalContentItem={technicalContentItem} />
          </div>
        ))}
      </TechnicalContentSectionWrapper>
    </BasePageSection>
  );
};

export default TechnicalContentSection;
